import { Button } from "@/components/ui/button";
import { i18n } from "@/i18n";
import { useWidgetStore } from "@/stores/widget-store";
import { saveWidgetConfig } from "@/services/widget";
import { useToast } from "@/hooks/use-toast";
import { useState } from "react";

export const WidgetPublish = () => {
  const [isPublishing, setIsPublishing] = useState(false);
  const widgetConfig = useWidgetStore((state) => state.config);
  const { toast } = useToast();

  const handlePublish = async () => {
    try {
      setIsPublishing(true);

      await saveWidgetConfig(widgetConfig);

      toast({
        title: i18n.__( 'Changes published successfully', 'accessibility-widget' ),
        variant: "success",
      });
    } catch {
      toast({
        title: i18n.__( 'Failed to publish changes', 'accessibility-widget' ),
        variant: "destructive",
      });
    } finally {
      setIsPublishing(false);
    }
  };

  return (
    <Button
      className="cy:rounded cy:text-base!"
      onClick={handlePublish}
      disabled={isPublishing}
    >
      {isPublishing ? i18n.__( 'Applying...', 'accessibility-widget' ) : i18n.__( 'Apply changes', 'accessibility-widget' )}
    </Button>
  );
};
